export const SORT_EDITOR_LOCALE_ZHCHS = {
    // åæ¶
    cancel: 'åæ¶',
    // ç¡®å®
    ok: 'ç¡®å®',
    // æ·»å å­å¥
    add: 'æ·»å ',
    clear: 'æ¸ç©º',
    // ç½®é¡¶
    moveTop: 'ç½®é¡¶',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: ' ç½®åº',

    // å­æ®µ
    field: 'å­æ®µ',
    // æåº
    order: 'æåº',
    asc: 'ååº',
    desc: 'éåº',
    title: 'æåºè®¾ç½®',
    clearAll: 'ç¡®è®¤è¦æ¸ç©ºæææåºå­æ®µåï¼'
};
